import { Endpoint, api } from "../data/api";

export function addAccount(characterId: number, accountName: string): Promise<any[]> {
  return api.post(Endpoint.addAccount, { characterId, accountName });
}